import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";
import { Button } from '@mui/material';

const { mobile, tablet, desktop } = MediaQuerys;

export const Container = styled('div')(({theme}) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
}))

export const Header = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.detailTextColor,
    width: '100%',
    height: 'fit-content',
    borderRadius: '10px 10px 0 0',
    padding: '16px',
    textTransform: 'uppercase',
    fontWeight: 600,
    [desktop]: {
      fontSize: '0.75rem',
    }
  }
})

export const Body = styled('div')(({ theme, isStandardFlow }) => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: isStandardFlow ? '2rem' : 0,
    background: colors.white,
    [theme.breakpoints.up('lg')]: {
      width: isStandardFlow && '800px'
    },
    [theme.breakpoints.down('lg')]: {
      width: isStandardFlow && '650px'
    },
    [theme.breakpoints.down('md')]: {
      width: isStandardFlow && '550px'
    },
    [theme.breakpoints.down('sm')]: {
      width: isStandardFlow && '90vw'
    },
  }
})

export const Footer = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius: '0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 16px',
    margin: 'auto'
  }
})

export const ContainerInfo = styled('div')(({disabled, isStandardFlow }) => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection:'column',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
  }
})

export const SectionRight = styled('section')(({ content }) => ({
  display: 'flex',
  width: content && '30%',
  flexDirection: content && 'row',
  justifyContent: content ? 'center' : 'flex-end',
  gap: '1rem',
  [mobile]: {
    width: content && '50%'
  }
}))


export const ContainerInputColor = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',
  }
})


export const ContainerIcon = styled('div')(() => {
  return {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  }
})


export const ContainerInputGroup = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '33%',
    gap: '1rem',
  }
})


export const CustomButton = styled(Button)(() => {
  const { colors } = useColors();
  return {
    height: 28, 
    padding: '0 20px', 
    color: colors.white,
    backgroundColor: colors.buttonActionColor,
    "&:hover": {
        backgroundColor: colors.gray,
        color: colors.buttonActionColor,
    },
    [desktop]: {
      height: 25,
      fontSize: '0.80rem',
    }
  }
})

export const CustomDivider = styled(Divider)(() => {
  const { colors } = useColors();

  return {
    color: colors.grayFont,
    fontWeight: 'bold',
    borderBottomWidth: '0.2rem'
  }
})